module.exports = __webpack_public_path__ + "static/media/app-store.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/app-store.svg
// module id = 559
// module chunks = 0